import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { BottomSheetBody, BottomSheetFooter, BottomSheetHeader, BottomSheetHeaderTitle, Flex, FlexColumn, Separator, Spinner, TextBody } from "@opensea/ui-kit";
import { differenceInMilliseconds, isAfter, max, min, parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { CancelOrderStatus } from "../CancelOrderFlowStatus";
import { CancelOrderTable } from "../CancelOrderTable";
import { GaslessCancelOrderStatusFragment } from "./GaslessCancelOrderStatus.fragment";
export const GaslessCancelOrderStatus = t0 => {
  const $ = _c(39);
  const {
    action: actionKey,
    signatureMap: defaultSignatureMap,
    forceOnchainCancellation
  } = t0;
  const t = useTranslations("wallet.GaslessCancelOrderStatus");
  const [signatureMap, setSignatureMap] = useState(defaultSignatureMap);
  const action = readFragment(GaslessCancelOrderStatusFragment, actionKey);
  let t1;
  if ($[0] !== signatureMap) {
    t1 = signatureMap || {};
    $[0] = signatureMap;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cancelledOrdersCount = Object.values(t1).filter(_temp).length;
  let t2;
  if ($[2] !== signatureMap) {
    t2 = Object.keys(signatureMap || {});
    $[2] = signatureMap;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const cancellationRequests = t2.length;
  const hasPendingCancellations = signatureMap && cancelledOrdersCount !== cancellationRequests;
  const count = cancelledOrdersCount || cancellationRequests;
  let orderIds = action.orders.map(_temp2);
  if (hasPendingCancellations) {
    let t3;
    if ($[4] !== signatureMap) {
      t3 = orderId => signatureMap[orderId] !== "";
      $[4] = signatureMap;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    orderIds = orderIds.filter(t3);
  }
  let t3;
  if ($[6] !== hasPendingCancellations || $[7] !== orderIds || $[8] !== signatureMap) {
    t3 = () => {
      let timeout = null;
      if (signatureMap && hasPendingCancellations) {
        const timestamps = Object.values(signatureMap).filter(Boolean);
        const earliestFutureTimestamp = min(timestamps);
        const latestTimestamp = max(timestamps);
        if (isAfter(new Date(), latestTimestamp) || !timestamps.length) {
          setSignatureMap(Object.fromEntries(orderIds.map(_temp3)));
        } else {
          if (isAfter(earliestFutureTimestamp, new Date())) {
            timeout = window.setTimeout(() => {
              const currentTime = new Date();
              const allOrderIds = Object.keys(signatureMap);
              const remainingOrders = allOrderIds.filter(orderId_1 => signatureMap[orderId_1] && isAfter(parseISO(signatureMap[orderId_1]), currentTime));
              setSignatureMap(Object.fromEntries(allOrderIds.map(orderId_2 => [orderId_2, remainingOrders.includes(orderId_2) ? signatureMap[orderId_2] : ""])));
            }, differenceInMilliseconds(earliestFutureTimestamp, new Date()));
          }
        }
      }
      return () => {
        if (timeout) {
          window.clearTimeout(timeout);
        }
      };
    };
    $[6] = hasPendingCancellations;
    $[7] = orderIds;
    $[8] = signatureMap;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = orderIds;
  let t5;
  if ($[10] !== hasPendingCancellations || $[11] !== signatureMap || $[12] !== t4) {
    t5 = [signatureMap, hasPendingCancellations, t4];
    $[10] = hasPendingCancellations;
    $[11] = signatureMap;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t3, t5);
  if (signatureMap && !hasPendingCancellations) {
    let t6;
    if ($[14] !== action) {
      t6 = <CancelOrderStatus orders={action.orders} status="success" />;
      $[14] = action;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Spinner />;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = action.orders[0].side === "LISTING" ? t("cancellingListings", {
    count
  }) : t("cancellingOffers", {
    count
  });
  let t8;
  if ($[17] !== t7) {
    t8 = <BottomSheetHeader><BottomSheetHeaderTitle asChild={true} className="flex items-center gap-2">{t6}<h3>{t7}</h3></BottomSheetHeaderTitle></BottomSheetHeader>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const T0 = BottomSheetBody;
  const T1 = FlexColumn;
  const t9 = "w-full gap-4";
  const t10 = signatureMap ? cancelledOrdersCount ? <TextBody size="sm">{action.orders[0].side === "LISTING" ? t("immediateCancellationListings", {
      count: cancelledOrdersCount
    }) : t("immediateCancellationOffers", {
      count: cancelledOrdersCount
    })}</TextBody> : <TextBody size="sm">{action.orders[0].side === "LISTING" ? t("pendingCancellationListings", {
      count
    }) : t("pendingCancellationOffers", {
      count
    })}</TextBody> : null;
  let t11;
  if ($[19] !== action.orders || $[20] !== orderIds) {
    t11 = <CancelOrderTable filteredOrderIds={orderIds} orders={action.orders} view="done" />;
    $[19] = action.orders;
    $[20] = orderIds;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== T1 || $[23] !== t10 || $[24] !== t11) {
    t12 = <T1 className={t9}>{t10}{t11}</T1>;
    $[22] = T1;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Separator />;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== T0 || $[28] !== t12) {
    t14 = <T0>{t12}{t13}</T0>;
    $[27] = T0;
    $[28] = t12;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("cancelWithGas");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== forceOnchainCancellation || $[33] !== t15) {
    t16 = <BottomSheetFooter><Flex className="justify-end"><Button onClick={forceOnchainCancellation} variant="secondary">{t15}</Button></Flex></BottomSheetFooter>;
    $[32] = forceOnchainCancellation;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t14 || $[36] !== t16 || $[37] !== t8) {
    t17 = <>{t8}{t14}{t16}</>;
    $[35] = t14;
    $[36] = t16;
    $[37] = t8;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
};
function _temp(timestamp) {
  return timestamp === "";
}
function _temp2(order) {
  return order.id;
}
function _temp3(orderId_0) {
  return [orderId_0, ""];
}